const FORM_FIELDS = Object.freeze({
  ID: 'id',
  JOB_LOCATION: 'jobLocation',
  JOB_NUMBER: 'jobNumber',
  OPENED_ON: 'openedOn',
  PRIORITY: 'priority',
  REQUESTER_EMAIL: 'requesterEmail',
  REQUESTER_NAME: 'requesterName',
  REQUESTER_PHONE: 'requesterPhone',
  SEVERITY: 'severity',
  TASK_LOCATION: 'taskLocation',
  WORK_ORDER_TASK_REQUEST: 'workOrderTaskRequest',
  STATUS: 'status',
  COMMENTS: 'comments',
  COMMENT: 'comment',
  RESOLVED_ON: 'resolvedOn',
  RESOLVER: 'resolver'
});

const REQUEST_STATUSES = Object.freeze({
  OPENED: 'Opened',
  RESOLVED: 'Resolved'
});

const getFieldsToValidate = (values) => {
  return [
    {
      name: FORM_FIELDS.JOB_NUMBER,
      errorMessage: 'Job number field is required',
      isInvalid: !values[FORM_FIELDS.JOB_NUMBER]
    },
    {
      name: FORM_FIELDS.JOB_LOCATION,
      errorMessage: 'Job location field is required',
      isInvalid: !values[FORM_FIELDS.JOB_LOCATION]
    },
    {
      name: FORM_FIELDS.PRIORITY,
      errorMessage: 'Priority field is required',
      isInvalid: !values[FORM_FIELDS.PRIORITY]?.name
    },
    {
      name: FORM_FIELDS.SEVERITY,
      errorMessage: 'Severity field is required',
      isInvalid: !values[FORM_FIELDS.SEVERITY]?.name
    },
    {
      name: FORM_FIELDS.TASK_LOCATION,
      errorMessage: 'Task location field is required',
      isInvalid: !values[FORM_FIELDS.TASK_LOCATION]
    },
    {
      name: FORM_FIELDS.WORK_ORDER_TASK_REQUEST,
      errorMessage: 'Work order field is required',
      isInvalid: !values[FORM_FIELDS.WORK_ORDER_TASK_REQUEST]
    },
    {
      name: FORM_FIELDS.COMMENT,
      errorMessage: 'Comment field is required',
      isInvalid: !values[FORM_FIELDS.COMMENT],
      checkCondition: !!values[FORM_FIELDS.ID]
    }
  ];
};

export { FORM_FIELDS, REQUEST_STATUSES, getFieldsToValidate };
